// @generated by protoc-gen-es v1.2.0 with parameter "target=js+dts"
// @generated from file wavin/aqora/v2/connectivity.proto (package wavin.aqora.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";

/**
 * The connectivity of a specific device
 *
 * @generated from message wavin.aqora.v2.Connectivity
 */
export const Connectivity = proto3.makeMessageType(
  "wavin.aqora.v2.Connectivity",
  () => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(Connectivity_Status) },
    { no: 2, name: "battery_percentage", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "signal_strength_percentage", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "signal_strength_dbm", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "network", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "latest_metrics_received", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from enum wavin.aqora.v2.Connectivity.Status
 */
export const Connectivity_Status = proto3.makeEnum(
  "wavin.aqora.v2.Connectivity.Status",
  [
    {no: 0, name: "STATUS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "STATUS_OK", localName: "OK"},
  ],
);

